import { ColumnDef } from "@tanstack/react-table";
import { useDocumentStore } from "../../../../stores/document.store";
import fileIcon from "../../../../assets/file_icon.png";
import { Badge } from "@dune/ui";
import { OfferFileDisplay } from "@dune/types";

export const constructionSiteOffersColumns: ColumnDef<OfferFileDisplay>[] = [
	{
		accessorKey: "createdAt",
		header: "Date de création",
		cell: ({ row }) => {
			const createdAt = row.original.createdAt;
			return createdAt
				? new Date(createdAt).toLocaleDateString("fr-FR")
				: "N/A";
		},
	},
	{
		id: "offre",
		header: "Offre",
		cell: ({ row }) => {
			const warrantyType = row.original.warrantyType;
			switch (warrantyType) {
				case "MRT":
					return "Offre Multirisques Travaux";
				case "DO":
					return "Offre Dommages Ouvrage";
				case "TRC":
					return "Offre Tous Risques Chantier";
				default:
					return "Offre";
			}
		},
	},
	{
		id: "assureur",
		header: "Assureur",
		cell: ({ row }) => {
			const insurerType = row.original.insurerType;
			return insurerType || "N/A";
		},
	},
	{
		id: "status",
		header: "Statut",
		cell: ({ row }) => (
			<Badge variant={!row.original.isDeleted ? "outlineGreen" : "outlineRed"}>
				{!row.original.isDeleted ? "Valide" : "Supprimé"}
			</Badge>
		),
	},
	{
		id: "documents",
		header: "Document(s)",
		cell: ({ row }) => {
			const selectDocument = useDocumentStore((state) => state.selectDocument);
			const file = row.original.files[0];
			if (!file) return null;
			return (
				<div className="flex">
					<button
						type="button"
						className="inline-flex items-center justify-center w-8 h-8 transition-colors cursor-pointer"
						title="Cliquer pour prévisualiser le document d'indication tarifaire"
						onClick={() =>
							selectDocument("", file.id, file.mimeType, file.name)
						}
					>
						<img src={fileIcon} alt="File Icon" className="w-8 h-8" />
					</button>
				</div>
			);
		},
	},
];
